// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { Options } from './Options.gen';
import type { PublicCardApplicationStateControllerGetAllData } from './PublicCardApplicationStateControllerGetAllData.gen';
import type { PublicCardApplicationStateControllerGetAllErrors } from './PublicCardApplicationStateControllerGetAllErrors.gen';
import type { PublicCardApplicationStateControllerGetAllResponses } from './PublicCardApplicationStateControllerGetAllResponses.gen';

export class PublicCardApplicationStateController {
    /**
     * Get card request possible states
     */
    public static getAll<ThrowOnError extends boolean = false>(options?: Options<PublicCardApplicationStateControllerGetAllData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicCardApplicationStateControllerGetAllResponses, PublicCardApplicationStateControllerGetAllErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/card-application-states',
            ...options
        });
    }
}
